"use client";

import {
	DiscoveryButton as UiDiscoveryButton,
	type DiscoveryButtonProps,
} from "@repo/ui/aops-components/DiscoveryButton";
import {trackDiscoveryLinkClick} from "@/lib/discoveryLinkTracking";

type AppDiscoveryButtonProps = Omit<DiscoveryButtonProps, "onLinkClick"> & {
	/** Runs before the shared Discovery link event, for surface-specific tracking. */
	onLinkClick?: DiscoveryButtonProps["onLinkClick"];
};

export function DiscoveryButton({
	onLinkClick,
	...props
}: AppDiscoveryButtonProps) {
	return (
		<UiDiscoveryButton
			{...props}
			onLinkClick={(href) => {
				onLinkClick?.(href);
				trackDiscoveryLinkClick(href, "discovery_button");
			}}
		/>
	);
}
